import { SolidgatePaymentModal } from '@feature/payment/solidgate/modals/SolidgatePaymentModal';
import { SolidgatePaymentStatusModal } from '@feature/payment/solidgate/modals/SolidgatePaymentStatusModal';

/**
 * Container for Solidgate payment components.
 * @see CustomerDashboard - this component is mounted only on CustomerDashboard pages.
 */
export const SolidgateContainer: FC = () => {
  return (
    <>
      {/**
       * Solidgate payment modal
       * - automatically opens when the merchantData & order are set in the Redux store (setOrderToPay)
       * @see paymentSlice
       * @see setOrderToPay
       */}
      <SolidgatePaymentModal />

      {/**
       * Solidgate payment status modal
       * - automatically opens when the payment status.id is updated in the Redux store (setPaymentStatus)
       * @see paymentSlice
       * @see setPaymentStatus
       */}
      <SolidgatePaymentStatusModal />
    </>
  );
};
